module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "c003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('b', [_vm._v("c. 150 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Antikythera Mechanism")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Found in 1900 in a shipwreck off the small island of Antikythera in Greece by sponge divers, at first glance the device appeared to be a hunk of corroded metal. Encased in the ocean’s slime was the most technologically advanced instrument to survive the ancient world. The Antikythera Mechanism is sometimes referred to as the world’s “first computer.” The instrument was designed to calculate and predict astronomical phenomena, seasons, and festivals. It was composed of more than 30 interlocking bronze gears in a wooden case the size of a shoebox.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turning the hand crank prompted the gears to turn, which rotated a series of dials and rings for simultaneous calculation of positions relative to the sun, moon, and possibly planets. The mechanism also predicted phases of the moon, eclipses, and calendar cycles. Inscriptions on the device include the Greek signs of the zodiac and references to Mars, Venus, and dates that correspond to what would likely have been the Olympiad, which began on the full moon closest to the summer solstice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is widely accepted by scholars that Greek scientists and mathematicians constructed the Antikythera Mechanism. The exact origin of its manufacture is still up for debate, but the (current) leading theory is that it came from the Greek island of Rhodes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mystery that persists is who owned and used the Antikythera Mechanism, and for what purpose. The knowledge it provided could have been as valued in a school or temple as in the home of a wealthy family, or even a political or military entity that used its capabilities for strategic decisions and planning. It also could have been used as an aid for crop planting, navigation, making land-based astronomical measurements, or predicting eclipses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Antikythera Mechanism was crafted using the steel tools available to the ancient Greeks. The miniaturization of the device’s components and the engineering in general is astonishing. Reproductions have been made to enable further study, and a fully working model was crafted using traditional techniques and tools to test how it may have been built.")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_c('b', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c001_r1"
    }
  }, [_vm._v("Sumerian Abacus (c. 2500 BCE)")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/Text/9781454926221_epub_c019_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas Arithmometer (1851)")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('i', [_vm._v("A modern reconstruction of the Antikythera Mechanism, considered by some to be the world’s")]), _vm._v(" “"), _c('i', [_vm._v("first computer.”")])]), _vm._v(" "), _c('div', {
    staticClass: "fig"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/21-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13fba8f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_c003_r1.vue
// module id = 81
// module chunks = 0